import './styles.scss'
import React, { useEffect, useState } from 'react'
import { I18n } from 'react-redux-i18n'

import TextEditor2 from 'components/Form/TextEditor/TextEditor2'
import ModalWrapper from 'components/ModalWrapper'
import PhoneViewer from 'components/PhoneViewer'

const Editor = ({ id, company, label, placeholder, value, options, onChange, isRequired, error }) => {
  const [isOpenPreviewModal, setIsOpenPreviewModal] = useState(false)
  const [currentChannelPreview, setCurrentChannelPreview] = useState('')
  const [innerValue, setInnerValue] = useState({})

  const togglePreviewModal = () => setIsOpenPreviewModal(!isOpenPreviewModal)

  useEffect(() => setInnerValue(value), [])

  return (
    <div className={`smartchat-field editor ${error ? 'editor--error' : ''}`}>
      {label && (
        <div className='smartchat-field__header'>
          {label && <label>{label}</label>}
          <span>{isRequired ? `(${I18n.t('dashboard_required')})` : `(${I18n.t('dashboard_optional')})`}</span>
        </div>
      )}
      <div className='smartchat-field__body'>
        <TextEditor2
          id={id}
          placeholder={placeholder}
          company={company}
          channel='smartchat'
          limit={0}
          value={innerValue?.contentHtml || innerValue?.content}
          buttons={innerValue?.buttons}
          attachments={innerValue?.attachments}
          options={options}
          onChange={data => {
            if (!data.value && !data.valueHtml && !data.buttons && !data.attachments) return
            const editorValue = {
              language: 'es',
              content: data.value || '',
              contentHtml: data.valueHtml || '',
              buttons: data.buttons || [],
              attachments: data.attachments || []
            }
            onChange(editorValue)
          }}
          dropZoneFilesHeight={183.84}
          minHeight={150}
          maxHeight={null}
          isTemplateValue
          currentChannelPreview={currentChannelPreview}
          onPreviewMsg={togglePreviewModal}
        />
      </div>
      <ModalWrapper
        isOpen={isOpenPreviewModal}
        toggle={togglePreviewModal}
        header={I18n.t('dashboard_preview')}
        eventBtnTxt={I18n.t('dashboard_close')}
        eventBtn={togglePreviewModal}
        contentClassName='modal-content-phone-preview'
        body={
          <div className='modal-content'>
            <PhoneViewer
              textPreview={innerValue}
              setCurrentChannelPreview={setCurrentChannelPreview}
            />
          </div>
        }
      />
    </div>
  )
}

export default Editor
